"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconNames = void 0;
var IconNames;
(function (IconNames) {
    IconNames[IconNames["AccountIcon"] = 0] = "AccountIcon";
    IconNames[IconNames["ArbeitgeberIcon"] = 1] = "ArbeitgeberIcon";
    IconNames[IconNames["ArrowLeftIcon"] = 2] = "ArrowLeftIcon";
    IconNames[IconNames["ArrowLeftRoundedIcon"] = 3] = "ArrowLeftRoundedIcon";
    IconNames[IconNames["ArrowRightIcon"] = 4] = "ArrowRightIcon";
    IconNames[IconNames["ArrowRightRoundedIcon"] = 5] = "ArrowRightRoundedIcon";
    IconNames[IconNames["AtomIcon"] = 6] = "AtomIcon";
    IconNames[IconNames["BVGLogoIcon"] = 7] = "BVGLogoIcon";
    IconNames[IconNames["CalculatorIcon"] = 8] = "CalculatorIcon";
    IconNames[IconNames["CalendarIcon"] = 9] = "CalendarIcon";
    IconNames[IconNames["CandleIcon"] = 10] = "CandleIcon";
    IconNames[IconNames["CardIcon"] = 11] = "CardIcon";
    IconNames[IconNames["ChangePlanIcon"] = 12] = "ChangePlanIcon";
    IconNames[IconNames["ChartIcon"] = 13] = "ChartIcon";
    IconNames[IconNames["ChartDownIcon"] = 14] = "ChartDownIcon";
    IconNames[IconNames["CheckmarkIcon"] = 15] = "CheckmarkIcon";
    IconNames[IconNames["ChevronDownIcon"] = 16] = "ChevronDownIcon";
    IconNames[IconNames["ChevronLeftIcon"] = 17] = "ChevronLeftIcon";
    IconNames[IconNames["ChevronRightIcon"] = 18] = "ChevronRightIcon";
    IconNames[IconNames["ChevronUpIcon"] = 19] = "ChevronUpIcon";
    IconNames[IconNames["CloseIcon"] = 20] = "CloseIcon";
    IconNames[IconNames["CloseRoundedIcon"] = 21] = "CloseRoundedIcon";
    IconNames[IconNames["CloudMailIcon"] = 22] = "CloudMailIcon";
    IconNames[IconNames["CockpitIcon"] = 23] = "CockpitIcon";
    IconNames[IconNames["CompanyIcon"] = 24] = "CompanyIcon";
    IconNames[IconNames["DocumentIcon"] = 25] = "DocumentIcon";
    IconNames[IconNames["DocumentMutationIcon"] = 26] = "DocumentMutationIcon";
    IconNames[IconNames["DocumentNotificationIcon"] = 27] = "DocumentNotificationIcon";
    IconNames[IconNames["DoneIcon"] = 28] = "DoneIcon";
    IconNames[IconNames["DottedCubeIcon"] = 29] = "DottedCubeIcon";
    IconNames[IconNames["DownloadIcon"] = 30] = "DownloadIcon";
    IconNames[IconNames["DownloadPDFIcon"] = 31] = "DownloadPDFIcon";
    IconNames[IconNames["DownloadXLSXIcon"] = 32] = "DownloadXLSXIcon";
    IconNames[IconNames["EditIcon"] = 33] = "EditIcon";
    IconNames[IconNames["EditSquareIcon"] = 34] = "EditSquareIcon";
    IconNames[IconNames["EmployerIcon"] = 35] = "EmployerIcon";
    IconNames[IconNames["ExitIcon"] = 36] = "ExitIcon";
    IconNames[IconNames["ExportIcon"] = 37] = "ExportIcon";
    IconNames[IconNames["ExternalLinkIcon"] = 38] = "ExternalLinkIcon";
    IconNames[IconNames["EyeIcon"] = 39] = "EyeIcon";
    IconNames[IconNames["EyeHideIcon"] = 40] = "EyeHideIcon";
    IconNames[IconNames["EyeShowIcon"] = 41] = "EyeShowIcon";
    IconNames[IconNames["FemaleIcon"] = 42] = "FemaleIcon";
    IconNames[IconNames["FemaleRoundedIcon"] = 43] = "FemaleRoundedIcon";
    IconNames[IconNames["FileTransferIcon"] = 44] = "FileTransferIcon";
    IconNames[IconNames["FilterIcon"] = 45] = "FilterIcon";
    IconNames[IconNames["HamburguerMenuIcon"] = 46] = "HamburguerMenuIcon";
    IconNames[IconNames["HeadBrainIcon"] = 47] = "HeadBrainIcon";
    IconNames[IconNames["HomeIcon"] = 48] = "HomeIcon";
    IconNames[IconNames["ICRBadgeIcon"] = 49] = "ICRBadgeIcon";
    IconNames[IconNames["ICRLogoIcon"] = 50] = "ICRLogoIcon";
    IconNames[IconNames["ImportIcon"] = 51] = "ImportIcon";
    IconNames[IconNames["KeyIcon"] = 52] = "KeyIcon";
    IconNames[IconNames["LogoutIcon"] = 53] = "LogoutIcon";
    IconNames[IconNames["MailIcon"] = 54] = "MailIcon";
    IconNames[IconNames["MaleIcon"] = 55] = "MaleIcon";
    IconNames[IconNames["MaleRoundedIcon"] = 56] = "MaleRoundedIcon";
    IconNames[IconNames["MinusRoundedIcon"] = 57] = "MinusRoundedIcon";
    IconNames[IconNames["NotificationIcon"] = 58] = "NotificationIcon";
    IconNames[IconNames["PensionDynamicsLogoIcon"] = 59] = "PensionDynamicsLogoIcon";
    IconNames[IconNames["PensionsKassenIcon"] = 60] = "PensionsKassenIcon";
    IconNames[IconNames["PeopleIcon"] = 61] = "PeopleIcon";
    IconNames[IconNames["PhoneIcon"] = 62] = "PhoneIcon";
    IconNames[IconNames["PigSafeBoxIcon"] = 63] = "PigSafeBoxIcon";
    IconNames[IconNames["PKSHLogoIcon"] = 64] = "PKSHLogoIcon";
    IconNames[IconNames["PlusIcon"] = 65] = "PlusIcon";
    IconNames[IconNames["PlusRoundedIcon"] = 66] = "PlusRoundedIcon";
    IconNames[IconNames["PrintIcon"] = 67] = "PrintIcon";
    IconNames[IconNames["ProPublicLogoIcon"] = 68] = "ProPublicLogoIcon";
    IconNames[IconNames["ProfileCardIcon"] = 69] = "ProfileCardIcon";
    IconNames[IconNames["QuestionIcon"] = 70] = "QuestionIcon";
    IconNames[IconNames["QuestionRoundedIcon"] = 71] = "QuestionRoundedIcon";
    IconNames[IconNames["RefreshIcon"] = 72] = "RefreshIcon";
    IconNames[IconNames["RockingChairIcon"] = 73] = "RockingChairIcon";
    IconNames[IconNames["SearchIcon"] = 74] = "SearchIcon";
    IconNames[IconNames["SlidersIcon"] = 75] = "SlidersIcon";
    IconNames[IconNames["SpyIcon"] = 76] = "SpyIcon";
    IconNames[IconNames["SuitcaseIcon"] = 77] = "SuitcaseIcon";
    IconNames[IconNames["SwitchLanguageIcon"] = 78] = "SwitchLanguageIcon";
    IconNames[IconNames["ThreeDotsHorizontalIcon"] = 79] = "ThreeDotsHorizontalIcon";
    IconNames[IconNames["ThreeDotsHorizontalRoundedIcon"] = 80] = "ThreeDotsHorizontalRoundedIcon";
    IconNames[IconNames["ThreeDotsVerticalIcon"] = 81] = "ThreeDotsVerticalIcon";
    IconNames[IconNames["TimeRefreshIcon"] = 82] = "TimeRefreshIcon";
    IconNames[IconNames["TrashIcon"] = 83] = "TrashIcon";
    IconNames[IconNames["UploadIcon"] = 84] = "UploadIcon";
    IconNames[IconNames["WebServiceIcon"] = 85] = "WebServiceIcon";
})(IconNames = exports.IconNames || (exports.IconNames = {}));
//# sourceMappingURL=types.js.map